module.exports = __webpack_public_path__ + "static/media/7.0fe5920b.jpg";